import React, { useRef, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { useTranslation } from "react-i18next";
import styles from "./TrustedCompanies.module.css";

function TrustedCompanies() {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const { t, i18n } = useTranslation("global");
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/companies`, {
          headers: {
            "Accept-Language": i18n.language,
          },
        });
        const result = await response.json();
        setCompanies(result?.data || []);
      } catch (error) {
        console.error("Error fetching companies:", error);
      }
    };

    fetchCompanies();
  }, [i18n.language]);

  return (
    <section className={styles.trustedCompaniesSection}>
      <div className="container">
        <div className={styles.sectionHeader}>
          <h1 className={styles.sectionTitle}>{t("ourInstructors.trust")}</h1>
        </div>

        <div className={styles.companiesContainer}>
          <div className={styles.swiperContainer}>
            <button
              ref={prevRef}
              className={styles.customPrevArrow}
              aria-label="Previous slide"
            >
              <i className="bi bi-chevron-right"></i>
            </button>
            
            <button
              ref={nextRef}
              className={styles.customNextArrow}
              aria-label="Next slide"
            >
              <i className="bi bi-chevron-left"></i>
            </button>

            <Swiper
              modules={[Navigation, Autoplay]}
              onSwiper={(swiper) => {
                if (prevRef.current && nextRef.current) {
                  swiper.params.navigation.prevEl = prevRef.current;
                  swiper.params.navigation.nextEl = nextRef.current;
                  swiper.navigation.init();
                  swiper.navigation.update();
                }
              }}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              spaceBetween={20}
              slidesPerView={5}
              breakpoints={{
                1200: { slidesPerView: 6 },
                992: { slidesPerView: 4 },
                768: { slidesPerView: 3 },
                576: { slidesPerView: 2 },
                425: { slidesPerView: 2 },
                375: { slidesPerView: 2 },
                325: { slidesPerView: 2 },
              }}
              className="myUniqueSwiper"
            >
              {companies.map((company, index) => (
                <SwiperSlide key={index}>
                  <div className={styles.companyLogoContainer}>
                    <img
                      src={company.image}
                      alt={company.name || "Company Logo"}
                      className={styles.companyLogo}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TrustedCompanies;
